/**
 * 处方笺图片打印
 *
 * 关键点：
 * 1. @page 只设置 margin，不设置 size。
 *    一旦写了 size（如 A4 landscape），Chrome 会隐藏打印弹框里的「布局（横向/纵向）」和「页面大小」选项，
 *    用户就无法自行切换方向；写 size: auto 则两者都保留，横向/纵向都能选。
 * 2. 打印内容按比例铺满整页：纸张方向由打印弹框决定，图片自动适配（不裁切、不变形）。
 *
 * 用法：printImage(document.getElementsByClassName('img-print0')[0])
 * 说明：打印时会临时替换 body 内容，打印结束后还原并刷新页面（与既有行为一致）。
 */

const PRINT_STYLE = `
@page {
  size: auto;
  margin: 0;
}

html,
body {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background: #ffffff !important;
}

.rx-print-sheet {
  width: 100%;
  height: 100%;
  overflow: hidden;
  page-break-after: avoid;
  break-after: avoid;
}

.rx-print-sheet img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
`

export default function printImage(holder) {
  if (!holder) return

  var img = holder.getElementsByTagName('img')[0]
  if (!img) return

  var src = img.currentSrc || img.src
  if (!src) return

  var origin = document.body.innerHTML
  var finished = false

  document.body.innerHTML =
    '<style>' +
    PRINT_STYLE +
    '</style><div class="rx-print-sheet"><img src="' +
    src +
    '"></div>'

  var printImg = document.body.getElementsByTagName('img')[0]

  var run = function () {
    if (finished) return
    finished = true
    // 等一帧，确保图片已完成解码后再唤起打印
    setTimeout(function () {
      window.print()
      document.body.innerHTML = origin
      window.location.reload()
    }, 80)
  }

  if (printImg && !printImg.complete) {
    printImg.onload = run
    printImg.onerror = run
    // 兜底：图片 3 秒内未加载完成时仍然允许打印
    setTimeout(run, 3000)
  } else {
    run()
  }
}
